import { IReferenceData } from '../../interfaces/form/reference-data.model';
import * as moment from 'moment';
import { map } from 'lodash';
import { getReferenceDataById } from '../../functions/get-reference-data-by-id';

export class RequestExtensionModel {
    assessmentInformation: AssessmentInformationRequest;
    evaluationSk: string;
    reviewDate: Date;
    extensionDays: number;
    reason: IReferenceData;
    otherReason: string;
    status: number;
    assessmentType: string;
    isApproved: boolean;
    newDueByDate: Date;
    extensionDaysApproved: number;
    otherReasonForRejection: string;
    DueBy: any;
    reasonForRejection: IReferenceData;
    evalutionName: string;
    dueDate: string;
    asstmtRejectionReasonOther: string;
    asstmtRejectionReason: IReferenceData;
    asstmtReviewApproved: boolean;
    submittedBy:string;
    constructor(data: any, refernceData: any) {
        this.evaluationSk = data?.evaluationSk;
        this.reviewDate = data.reviewAssessment?.reviewDate ? moment(data.reviewAssessment?.reviewDate).toDate() : undefined;
        this.extensionDays = data?.reviewAssessment?.extensionDays;
        this.reason = getReferenceDataById(data?.reviewAssessment?.reason, refernceData.reason),
            this.otherReason = data?.reviewAssessment?.otherReason;
            this.asstmtRejectionReason = getReferenceDataById(data?.reviewAssessment?.asstmtRejectionReason, refernceData.reason),
            this.asstmtRejectionReasonOther = data?.reviewAssessment?.asstmtRejectionReasonOther;
        this.status = 5;
        this.isApproved = data?.reviewAssessment?.isApproved;
        this.assessmentType = data?.reviewAssessment?.assessmentType;
        this.assessmentInformation = new AssessmentInformationRequest(data?.assessmentInformation);
        this.extensionDaysApproved = data?.reviewAssessment?.extensionDaysApproved,
            this.newDueByDate = data.reviewAssessment?.newDueByDate ? moment(data.reviewAssessment?.newDueByDate).toDate() : undefined;
        this.isApproved = data.reviewAssessment?.isApproved
        this.reasonForRejection = getReferenceDataById(data?.reviewAssessment?.reasonForRejection, refernceData.reason),
            this.otherReasonForRejection = data?.reviewAssessment?.otherReasonForRejection;
        this.DueBy = new Date(data?.DueBy);
        this.evalutionName = data?.reviewAssessment?.evalutionName;
        this.dueDate = data?.reviewAssessment?.dueDate
        this.asstmtReviewApproved = data?.reviewAssessment?.asstmtReviewApproved
        this.submittedBy = data?.reviewAssessment?.submittedBy;
    }

    get id(): string {
        return this.evaluationSk
    }
}

export class AssessmentInformationRequest {
    assessmentDates: Date[];

    constructor(data: any) {
        this.assessmentDates = map(data?.assessmentDates, (d: string) => moment(d).toDate());
    }
}